import React from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import { C } from "../ipd-billing/constants";

function timelineBaseUrl() {
  return (
    (process.env.REACT_APP_IS_TIMELINE_CONNECTED_WITH_PROD === "true"
      ? process.env.REACT_APP_TIMELINE_BASE_URL_PROD
      : process.env.REACT_APP_TIMELINE_BASE_URL_DEV) || ""
  );
}

/**
 * Patient timeline only — same iframe URL as Patient360Modal, without the
 * Summary / Analytics / ABDM / Local tabs.
 */
export default function PatientTimelineDialog({
  open,
  onClose,
  patientId,
  patientName,
}) {
  const resolvedId = String(patientId || "").trim();
  const base = timelineBaseUrl();
  const orgCode = sessionStorage.getItem("ORG_CODE") || "";
  const src =
    open && resolvedId && base
      ? `${base}/timeline/?org=${encodeURIComponent(orgCode)}&patient_id=${encodeURIComponent(resolvedId)}`
      : "";

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      sx={{ zIndex: 2200 }}
    >
      <DialogTitle sx={{ fontWeight: 700, pb: 1 }}>
        Patient timeline
        {patientName ? (
          <Typography
            component="span"
            sx={{
              display: "block",
              fontSize: 13,
              fontWeight: 500,
              color: C.textSub,
              mt: 0.5,
            }}
          >
            {patientName}
          </Typography>
        ) : null}
      </DialogTitle>
      <DialogContent sx={{ pt: 0, height: "75vh" }}>
        {src ? (
          <iframe
            src={src}
            title="Patient Timeline"
            style={{
              width: "100%",
              height: "100%",
              border: "none",
            }}
          />
        ) : (
          <Typography sx={{ fontSize: 13, color: C.textSub, py: 3 }}>
            Patient timeline is unavailable for this report.
          </Typography>
        )}
      </DialogContent>
      <DialogActions>
        <Button type="button" onClick={onClose}>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
}
